import { Box, Divider, List, ListItem, ListItemText, Typography } from "@mui/material"
import AccountBoxIcon from "@mui/icons-material/AccountBox"
import ShopIcon from "@mui/icons-material/Shop"
import StarRateIcon from "@mui/icons-material/StarRate"
import FavoriteIcon from "@mui/icons-material/Favorite"
import SearchIcon from "@mui/icons-material/Search"
import GroupIcon from "@mui/icons-material/Group"
import PostAddIcon from "@mui/icons-material/PostAdd"
import VisibilityIcon from "@mui/icons-material/Visibility"
import PreviewIcon from "@mui/icons-material/Preview"
import Icn from "../UI/SharieIcn/SharieIcn"
import React from "react"
import { useNavigate } from "react-router-dom"
import useTranslationSharie from "../hooks/Language/useTranslation"
import { useApiService } from "../hooks/Api/useApiService"
import styles from "./LinksActivity.module.css"

const LinksActivity = ({ notifications, style, ...props }) => {
  const navigate = useNavigate()
  const t = useTranslationSharie()
  const { postData } = useApiService()

  const getTypeIcon = (type) => {
    switch (type) {
      case "view profile":
        return <AccountBoxIcon />
      case "view skill":
        return <VisibilityIcon />
      case "view group":
        return <PreviewIcon />
      case "buy skill":
        return <ShopIcon />
      case "rated skill":
        return <StarRateIcon />
      case "like":
        return <FavoriteIcon />
      case "search":
        return <SearchIcon />
      case "joined group":
        return <GroupIcon />
      case "post skill":
        return <PostAddIcon />
      case "search group":
        return <SearchIcon />
      default:
        return <PreviewIcon />
    }
  }
  const handleClickItem = (notification) => {
    try {
      postData("sharie/addnotification", {
        skill_name: notification.skill_name,
        from: notification.to,
        to: notification.from,
        type: "view profile",
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
    navigate("/profile", { state: { user_name: notification.from, editable: false } })
  }
  return (
    <div
      style={{
        width: "300px",
        height: "550px",
        backgroundColor: "rgba(54, 79, 191, 0.3)", // #364fbf with alpha for translucency
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)", // for Safari support
        borderRadius: "12px",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0 8px 32px 0 rgba(54, 79, 191, 0.37)",
        color: "text.primary",
        padding: "16px",
        ...style,
      }}
      {...props}
    >
      <List>
        {notifications && notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <React.Fragment key={index}>
              <ListItem
                onClick={() => handleClickItem(notification)}
                className={notification.seen ? "" : styles.li_selected}
              >
                <ListItemText
                  secondary={
                    <Box
                      display='flex'
                      alignItems='center'
                      justifyContent='space-between'
                      width='100%'
                      gap={1}
                    >
                      <Box flex={1} textAlign='center'>
                        <strong>{notification.from}</strong>
                      </Box>
                      <Box flex={1} display='flex' justifyContent='center' alignItems='center'>
                        <Icn
                          tooltip={t(notification.type)}
                          color='inherit'
                          icon={getTypeIcon(notification.type)}
                          onClick={() => {
                            navigate("/profile", {
                              state: { user_name: notification.from, editable: false },
                            })
                          }}
                        />
                      </Box>
                      <Box flex={1} textAlign='center'>
                        <strong>{notification.skill_name}</strong>
                      </Box>
                    </Box>
                  }
                />
              </ListItem>
              {index < notifications.length - 1 && <Divider />}
            </React.Fragment>
          ))
        ) : (
          <Typography variant='body2' color='text.secondary' align='center'>
            {t("No notifications available")}
          </Typography>
        )}
      </List>
    </div>
  )
}

export default LinksActivity
